module.exports = __webpack_public_path__ + "img/qr.b6d4c51c.png";